import { UpfrontPaymentSummary } from '@dgx-pr-spa/shared/util';
import { Store } from '@ngrx/store';
import { CompleteOrderService } from '@complete-order/services/complete-order.service';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromUpfrontPayment from '../actions/upfront.payment.action';
import * as fromUpfrontPaymentState from '../reducers/upfront.payment.reducer';
import { withLatestFrom, tap } from 'rxjs/operators';

@Injectable()
export class UpfrontPaymentEffects {
  constructor(
    public readonly actions$: Actions,
    public readonly store: Store<fromUpfrontPaymentState.UpfrontPaymentState>,
    public readonly completeOrderService: CompleteOrderService
  ) {}

  loadUpfrontPayment$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromUpfrontPayment.loadUpfrontPayment),
        withLatestFrom(this.completeOrderService.upfrontPaymentArgs$),
        tap(([, payload]) => {
          this.store.dispatch(
            fromUpfrontPayment.loadUpfrontPaymentSuccess({
              payload: payload as UpfrontPaymentSummary,
            })
          );
        })
      ),
    { dispatch: false }
  );
}
